<template>
  <div class="case-category">
    <div class="admin-left">
      <mynav></mynav>
    </div>
    <div class="main">
      <el-card>
        <h4 style="font-size: 24px; margin-bottom: 30px">案例列表</h4>
        <el-button type="primary" @click="add">添加 <i class="el-icon-edit"></i></el-button>
        <el-table :data="list" border class="table">
          <el-table-column prop="title" label="案例类型" min-width="60%"></el-table-column>
          <el-table-column prop="cover" label="封面" min-width="20%">
            <template slot-scope="scope">
              <img :src="imgUrl(scope.row)" style="height: 45px"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="20%">
            <template slot-scope="scope">
              <el-button type="primary" class="el-icon-edit" @click="edit(scope.row)">编 辑</el-button>
              <el-button type="danger" class="el-icon-delete" @click="remove(scope.row)">删 除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination style="margin-top: 10px"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"
                       :current-page="page.page"
                       :page-sizes="[10, 20, 30, 40]"
                       layout="total, sizes, prev, pager, next"
                       :total="page.total">
        </el-pagination>
        <!--编辑对话框-->
        <el-dialog title="添加案例分类" :visible.sync="dialogFormVisible" @close="clear">
          <el-form :model="form" label-width="120px" ref="form">
            <el-form-item label="添加封面:">
              <el-upload
                  class="avatar-uploader"
                  :action="uploadURL"
                  :headers="uploadHeaders"
                  :show-file-list="false"
                  :on-success="CoverSuccess"
                  :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.cover" :src="form.cover" class="avatar" width="400px"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="案例类型名称:" prop="name">
              <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="clear">取 消</el-button>
            <el-button type="primary" @click="update" v-if="form.id">更 新</el-button>
            <el-button type="primary" @click="submit" v-else>确 定</el-button>
          </div>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import mynav from "../../components/leftnav.vue";
import {getToken} from "../../token";

export default {
  name: "case_category",
  components: {
    mynav
  },
  mounted() {
    //图片上传地址
    this.uploadURL = process.env.VUE_APP_BASE_API + "/oss/upload";
    this.uploadHeaders = {
      token: getToken(),
    };
    this.getList()
  },
  data() {
    return {
      uploadHeaders: '',
      uploadURL: '',
      // 对话框的显示与否
      dialogFormVisible: false,
      // 新增表单
      form: {
        title: undefined,
        cover: ''
      },
      // 所有关于案例的列表数据
      list: [],
      page: {
        page: 1,
        size: 10,
        total: 0
      },
    }
  },
  methods: {
    imgUrl(row) {
      if(row.cover){
        return row.cover
      }
      return 'https://superscreen.oss-cn-shanghai.aliyuncs.com/cover.jpg'
    },
    //上传格式限制
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 50;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 50MB!");
      }
      return isLt2M;
    },
    CoverSuccess(res) {
      if (res.code == 200) {
        this.$set(this.form, "cover", res.data);
        // this.cover.url = res.data;
      } else {
        this.$message({
          type: "error",
          message: "上传banner图失败!",
        });
      }
    },
    // 向服务端提交数据
    async submit() {
      let data = this.form
      let rs = await this.$axios.post("/case/incr", data)
      // 如果后端返回的代码为200，此时表示保存成功
      if (rs.code === 200) {
        // 数据保存成功，刷新整个页面
        location.reload()
      }
    },
    // 添加新的安例
    add() {
      this.dialogFormVisible = true
    },
    // 当点击弹窗对话框的关闭或者取消时
    clear() {
      this.dialogFormVisible = false
      this.form = {
        title: undefined
      }
      this.$refs.form.resetFields()
    },
    // 获取list
    async getList() {
      const rs = await this.$axios.get("/case/category_list?is_delete=1&page=" + this.page.page + "&size=" + this.page.size)
      if (rs.code === 200) {
        this.list = rs.data.list
        this.page.total = rs.data.totalRow
      }
    },
    // 编辑信息
    async edit(row) {
      this.dialogFormVisible = true
      const rs = await this.$axios.get("/case/category_info?id=" + row.id)
      if (rs.code === 200) {
        this.form = rs.data
      }
    },
    // 删除数据
    async remove(row) {
      const rs = await this.$axios.get("/case/category_remove?id=" + row.id)
      if (rs.code === 200) {
        location.reload()
      }
    },
    // 更新数据
    async update() {
      let data = {id: this.form.id, title: this.form.title, cover: this.form.cover}
      const rs = await this.$axios.post("/case/category_update", data)
      if (rs.code === 200) {
        location.reload()
      }
    },
    // 当页码改变时
    handleSizeChange(size) {
      this.page.size = size
      this.getList()
    },
    handlePageChange(page) {
      this.page.page = page
      this.getList()
    },

  },
  computed: {

  }
}
</script>

<style scoped>
.table {
  margin-top: 10px;
}

.case-category {
  display: flex;
  justify-content: start;
}

.main {
  width: 100%;
  margin: 45px 10px;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>
